import icon_1 from 'Images/icons/1.svg';
import icon_1_1 from 'Images/icons/1_1.svg';
import icon_1_2 from 'Images/icons/1_2.svg';
import icon_1_3 from 'Images/icons/1_3.svg';
import icon_1_5a from 'Images/icons/1_5a.svg';
import icon_1_5b from 'Images/icons/1_5b.svg';
import icon_2 from 'Images/icons/2.svg';
import icon_2_1 from 'Images/icons/2_1.svg';
import icon_2_2 from 'Images/icons/2_2.svg';
import icon_2_5a from 'Images/icons/2_5a.svg';
import icon_2_5b from 'Images/icons/2_5b.svg';
import icon_3 from 'Images/icons/3.svg';
import icon_3_1 from 'Images/icons/3_1.svg';
import icon_3_2 from 'Images/icons/3_2.svg';
import icon_3_3 from 'Images/icons/3_3.svg';
import icon_3_4 from 'Images/icons/3_4.svg';
import icon_4 from 'Images/icons/4.svg';
import icon_4_1 from 'Images/icons/4_1.svg';
import icon_4_2 from 'Images/icons/4_2.svg';
import icon_4_4 from 'Images/icons/4_4.svg';
import icon_4_5 from 'Images/icons/4_5.svg';
import icon_5 from 'Images/icons/5.svg';
import icon_5_1 from 'Images/icons/5_1.svg';
import icon_5_2 from 'Images/icons/5_2.svg';
import icon_5_4a from 'Images/icons/5_4a.svg';
import icon_6 from 'Images/icons/6.svg';
import icon_6a from 'Images/icons/6a.svg';
import icon_6b from 'Images/icons/6b.svg';
import icon_7_1b from 'Images/icons/7_1b.svg';
import icon_7_1d from 'Images/icons/7_1d.svg';
import icon_7_2b from 'Images/icons/7_2b.svg';
import icon_7_1c from 'Images/icons/7_1c.svg';
import icon_8 from 'Images/icons/8.svg';
import icon_8_1 from 'Images/icons/8_1.svg';
import icon_8_2 from 'Images/icons/8_2.svg';
import icon_8_3 from 'Images/icons/8_3.svg';
import icon_9 from 'Images/icons/9.svg';
import icon_9_1 from 'Images/icons/9_1.svg';
import icon_10 from 'Images/icons/10.svg';
import icon_10_1 from 'Images/icons/10_1.svg';
import icon_10_2 from 'Images/icons/10_2.svg';
import noCombination from 'Images/icons/no_combination.svg';

// 94
const ceilingIcon = mountingType => {
  switch (mountingType) {
    case 100:
    case 359:
      return icon_1_1;
    case 101:
      return icon_1_2;
    case 102:
      return icon_1_3;
    case 357:
      return icon_1_5a;
    case 358:
      return icon_1_5b;
    default:
      return icon_1;
  }
};

// 95
const wallIcon = mountingType => {
  switch (mountingType) {
    case 100:
    case 359:
      return icon_2_1;
    case 101:
      return icon_2_2;
    case 108:
      return icon_7_1b;
    case 357:
      return icon_2_5a;
    case 358:
      return icon_2_5b;
    default:
      return icon_2;
  }
};

// 96
const floorIcon = mountingType => {
  switch (mountingType) {
    case 100:
    case 359:
      return icon_3_1;
    case 101:
      return icon_3_2;
    case 354:
      return icon_3_3;
    case 355:
      return icon_3_4;
    case 108:
      return icon_7_2b;
    default:
      return icon_3;
  }
};

// 97
const tableIcon = mountingType => {
  switch (mountingType) {
    case 100:
      return icon_4_1;
    case 101:
      return icon_4_2;
    case 355:
      return icon_4_4;
    case 359:
      return icon_4_5;
    default:
      return icon_4;
  }
};

// 98
const furnitureShelfIcon = mountingType => {
  switch (mountingType) {
    case 100:
      return icon_8_1;
    case 101:
      return icon_8_2;
    case 359:
      return icon_8_3;
    default:
      return icon_8;
  }
};

// 99
const poleIcon = mountingType => {
  switch (mountingType) {
    case 106:
      return icon_6a;
    case 107:
      return icon_6b;
    default:
      return icon_6;
  }
};

// 104
const groundIcon = mountingType => {
  switch (mountingType) {
    case 100:
      return icon_5_1;
    case 101:
      return icon_5_2;
    case 354:
      return icon_5_4a;
    case 108:
      return icon_7_1c;
    default:
      return icon_5;
  }
};

// 352
const cableIcon = mountingType => {
  switch (mountingType) {
    case 360:
      return icon_9_1;
    default:
      return icon_9;
  }
};

// 353
const facadeIcon = mountingType => {
  switch (mountingType) {
    case 100:
    case 359:
      return icon_10_1;
    case 101:
      return icon_10_2;
    case 108:
      return icon_7_1d;
    default:
      return icon_10;
  }
};

export default function getCriteriaIcon(mountingPosition, mountingType) {
  switch (mountingPosition) {
    case 94:
      return ceilingIcon(mountingType);
    case 95:
      return wallIcon(mountingType);
    case 96:
      return floorIcon(mountingType);
    case 97:
      return tableIcon(mountingType);
    case 98:
      return furnitureShelfIcon(mountingType);
    case 99:
      return poleIcon(mountingType);
    case 104:
      return groundIcon(mountingType);
    case 352:
      return cableIcon(mountingType);
    case 353:
      return facadeIcon(mountingType);
    default:
      return noCombination;
  }
}
